import React from 'react';
import { Card, Grid, Stack, Text } from '@mantine/core';
import { IconBuildingSkyscraper, IconStairs } from '@tabler/icons-react';
import type { ICotizacionServicios } from '../../../modelos/CotizadorServicios/entidades/ICotizacionServicios';
import type { IResultadoCotizacionServicios } from '../../../modelos/CotizadorServicios/entidades/IResultadoCotizacionServicios';
import { TablaResumenFamiliaVista, type IColumnaFamilia } from './tablaResumenFamiliaVista';

const numero = (valor?: number, unidad = '') => (valor ? `${valor.toLocaleString('es-CO')}${unidad}` : '-');

const COLUMNAS_ASCENSORES: IColumnaFamilia[] = [
    { encabezado: 'Capacidad', valor: l => numero(l.Capacidad, ' kg') },
    { encabezado: 'Velocidad', valor: l => numero(l.Velocidad, ' m/s') },
    { encabezado: 'Paradas', valor: l => numero(l.Paradas) }
];

const COLUMNAS_ESCALERAS: IColumnaFamilia[] = [
    { encabezado: 'Altura / Longitud', valor: l => numero(l.Recorrido, ' mm') },
    { encabezado: 'Velocidad', valor: l => numero(l.Velocidad, ' m/s') }
];

interface ResumenComercialVistaProps {
    cotizacion: ICotizacionServicios;
    resultado: IResultadoCotizacionServicios;
    nombrePais?: string;
    porcentajeIva: number;
}

const Dato: React.FC<{ etiqueta: string; valor?: string | number }> = ({ etiqueta, valor }) => (
    <Grid.Col span={{ base: 6, md: 3 }}>
        <Text size="xs" c="dimmed">{etiqueta}</Text>
        <Text size="sm" fw={500}>{valor || '-'}</Text>
    </Grid.Col>
);

/** Lo que ve el cliente: encabezado del documento y una tabla por familia de equipos. */
export const ResumenComercialVista: React.FC<ResumenComercialVistaProps> = ({ cotizacion, resultado, nombrePais, porcentajeIva }) => (
    <Stack gap="md">
        <Card withBorder radius="md" p="md">
            <Grid>
                <Dato etiqueta="Proyecto" valor={cotizacion.Proyecto} />
                <Dato etiqueta="Cliente" valor={cotizacion.Cliente} />
                <Dato etiqueta="País" valor={nombrePais} />
                <Dato etiqueta="Año" valor={cotizacion.Anio} />
                <Dato etiqueta="Código" valor={cotizacion.CodigoFormato} />
                <Dato etiqueta="Versión" valor={cotizacion.VersionFormato} />
                <Dato etiqueta="Fecha" valor={cotizacion.FechaCreacion ? new Date(cotizacion.FechaCreacion).toLocaleDateString('es-CO') : undefined} />
                <Dato etiqueta="Elaboró" valor={cotizacion.UsuarioCreadorNombre} />
            </Grid>
        </Card>

        {resultado.Ascensores.Lineas.length > 0 && (
            <TablaResumenFamiliaVista
                titulo="Ascensores"
                icono={<IconBuildingSkyscraper size={18} />}
                resultado={resultado.Ascensores}
                columnas={COLUMNAS_ASCENSORES}
                porcentajeIva={porcentajeIva}
            />
        )}
        {resultado.Escaleras.Lineas.length > 0 && (
            <TablaResumenFamiliaVista
                titulo="Escaleras, Rampas y Andenes"
                icono={<IconStairs size={18} />}
                resultado={resultado.Escaleras}
                columnas={COLUMNAS_ESCALERAS}
                porcentajeIva={porcentajeIva}
            />
        )}
    </Stack>
);
